import React from 'react';
import stores from 'stores/mobx';

export const storesContext = React.createContext(stores);

const useStores = (): typeof stores => React.useContext(storesContext);

export default useStores;
